import Vue from 'vue';

const api = JSON.parse(document.getElementById('api').textContent);

const app = new Vue({
    el: "#app",
    data: {
        origin: [],
        results: [],
        subs: [],
        area: "",
        sub: ""
    },
    mounted() {
        this.origin = api;
        this.area = this.origin !== undefined ? parseInt(this.origin[0].id) : "";
        this.handleArea();
    },
    methods: {
        handleArea() {
            const area = this.origin.find((item) => item.id === parseInt(this.area));
            if (area.subs !== undefined) {
                this.subs = area.subs;
                if (area.subs.length > 0) {
                    this.sub = area.subs[0].id;
                    this.results = area.subs[0].distributors;
                } else {
                    this.results = [];
                }
            } else {
                this.results = [];
                this.subs = [];
                this.$nextTick(() => {
                    this.results = area.distributors;
                });
            }
        },
        handleSub() {
            var sub = this.subs.find((item) => item.id === parseInt(this.sub));
            this.results = [];
            this.$nextTick(() => {
                this.results = sub.distributors;
            });
        },
        notEmpty(data) {
            console.log(data);
            return data !== "" && data !== undefined && data !== null && data !== 'null';
        }
    }
});
